import { AppModule } from 'app/module';
import { FollowButton } from 'module/followButton/main';
import { CompanyFollowLoginInfo } from 'module/companyFollowLoginInfo/main';
import { CompanyCardImage } from 'module/companyCardImage/main';
import Template from './template.hbs';
import './styles.scss';

export class CompanyCard extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            followButton: '.m-companyCard__followButton .m-followButton',
            companyFollowLoginInfo: '.m-companyFollowLoginInfo',
            companyTags: ['.m-companyCard__tag'],
            companyCardImage: '.m-companyCardImage',
            companyLocations: ['.m-companyCard__location'],
        };
    }

    subEvents() {
        if (this.companyFollowLoginInfo) {
            this.companyFollowLoginInfo.events.on('onCloseButtonClicked', () => this.closeCompanyFollowLoginInfo());
        }
    }

    subs() {
        if (this.dom.followButton !== null) { // if inactive jobs ...
            this.followButton = new FollowButton(this.dom.followButton);
        }
        if (this.dom.companyFollowLoginInfo) {
            this.companyFollowLoginInfo = new CompanyFollowLoginInfo(this.dom.companyFollowLoginInfo);
        }
        this.companyCardImage = new CompanyCardImage(this.dom.companyCardImage);
    }

    subsProps() {
        if (this.followButton) {
            this.followButton.updateProps({ id: this.props.id });
        }
        if (this.companyFollowLoginInfo) {
            this.companyFollowLoginInfo.updateProps({ id: this.props.id });
        }
    }

    domEvents() {
        for (let i = 0; i < this.dom.companyTags.length; i += 1) {
            this.dom.companyTags[i].addEventListener('click', (e) => this.companyTagsClicked(e));
        }
        for (let i = 0; i < this.dom.companyLocations.length; i += 1) {
            this.dom.companyLocations[i].addEventListener('click', (e) => this.companyLocationsClicked(e));
        }
    }

    companyTagsClicked(e) {
        if (e) e.preventDefault();
        const companyTag = e.target.innerHTML;
        this.events.emit('changedCompanyTag', { keywords: companyTag });
    }

    companyLocationsClicked(e) {
        if (e) e.preventDefault();

        const locations = e.target.innerHTML;
        const locationSlug = e.target.getAttribute('data-slug');
        this.events.emit('changedCompanyLocation', { locations, locationSlug, states: {}, countries: {} });
    }

    getPropsFromDom() {
        return {
            id: this.dom.el.getAttribute('data-id'),
        };
    }

    closeCompanyFollowLoginInfo() {
        if (this.companyFollowLoginInfo) {
            this.companyFollowLoginInfo.updateProps({ visible: false }, true);
        }
    }
}
